const RESOURCE_NAME = '/maintenance-contact-groups';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});